import { render, staticRenderFns } from "./mNewsDetail.vue?vue&type=template&id=946fcc12&scoped=true&"
import script from "./mNewsDetail.vue?vue&type=script&lang=js&"
export * from "./mNewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./mNewsDetail.vue?vue&type=style&index=0&id=946fcc12&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946fcc12",
  null
  
)

export default component.exports